import React, { useState, ReactNode } from "react";
import { TnCContext } from "../contexts/TnCContext";
import { TnCContextType } from "../types/tnc";


interface TnCProviderProps {
  children: ReactNode;
}

export const TnCProvider: React.FC<TnCProviderProps> = ({ children }) => {
  const [accepted, setAccepted] = useState<boolean>(true);

  const contextValue: TnCContextType = {
    accepted,
    setAccepted,
  };

  return (
    <TnCContext.Provider value={contextValue}>
      {children}
    </TnCContext.Provider>
  );
};
